const validate = (
  maxLocationsAllowed: number,
  locations: {
    [id: string]: string;
  }
): boolean | string =>
  !locations ||
  Object.keys(locations).length <= maxLocationsAllowed ||
  `You have exceeded the max number of ${maxLocationsAllowed} locations`;

const curry = (functionToBeReturned) => (firstParam) => (secondParam) =>
  functionToBeReturned(firstParam, secondParam);

export const maxLocationsAllowedValidation = curry(validate);
